import { Theme } from '@material-ui/core/styles/createMuiTheme';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import deepmerge from 'deepmerge';
import React, { FunctionComponent } from 'react';
import { connect } from 'react-redux';
import { compose, pure } from 'recompose';
import { ItineraryStatus } from '../models/itinerary';
import { AppState } from '../store/model';
import {
  getStatus,
  isSaviSelectIntl,
} from '../store/reducers/itinerary/selectors';
import { breakpointMobile } from './lab/breakpoints';
import { spacings } from './lab/spacings';
import { ChangesRequested } from './notifications/ChangesRequested';
import { Info } from './notifications/Info';
import { SentToArranger } from './notifications/SentToArranger';

interface OwnProps {}

interface StateProps {
  status?: ItineraryStatus;
  isSaviSelectIntl: boolean;
}

interface TripNotificationProps
  extends OwnProps,
    StateProps,
    WithStyles<typeof styles> {}

const getStatusComponent = (
  status: ItineraryStatus,
  isSaviSelectIntl: boolean,
) => {
  switch (status) {
    case 'Accepted':
    case 'AcceptedWithChanges':
      return <SentToArranger isSaviSelectIntl={isSaviSelectIntl} />;
    case 'Rejected':
      return <ChangesRequested isSaviSelectIntl={isSaviSelectIntl} />;
    case 'New':
      return <Info isSaviSelectIntl={isSaviSelectIntl} />;
    default:
      return null;
  }
};

const TripNotificationBase: FunctionComponent<TripNotificationProps> = ({
  classes,
  status,
  isSaviSelectIntl,
}) => {
  if (!status) return null;

  return (
    <div className={classes.root}>
      {getStatusComponent(status, isSaviSelectIntl)}
    </div>
  );
};

const mapStateToProps = (state: AppState): StateProps => {
  return {
    status: getStatus(state),
    isSaviSelectIntl: isSaviSelectIntl(state),
  };
};

// styled
const styles = (theme: Theme) => {
  const {
    between: {
      card: { header: headerSpacing },
    },
  } = spacings(theme);

  const mobile = breakpointMobile(theme);

  const {
    spacing: { unit: spacing },
  } = theme;

  return createStyles({
    root: deepmerge(headerSpacing, {
      [mobile]: {
        paddingLeft: spacing * 2,
        paddingRight: spacing * 2,
      },
    }),
  });
};

const enhance = compose<TripNotificationProps, OwnProps>(
  pure,
  connect(mapStateToProps),
  withStyles(styles),
);

/**
 * Notifications for:
 *
 * - Accepted (`SentToArranger`)
 * - AcceptedWithChanges (`SentToArranger`)
 * - Rejected (`ChangesRequested`)
 * - New (`Info`)
 */
export const TripNotification = enhance(TripNotificationBase);

TripNotification.displayName = 'TripNotification';
